import { SSOAPIBaseError } from './sso-api-base-error';

export class SSOAPIContextParseFailure extends SSOAPIBaseError {};
